export default "__VITE_ASSET__042a9ac7__"